import { render, staticRenderFns } from "./tabulator-report-table.vue?vue&type=template&id=5d631099"
import script from "./tabulator-report-table.vue?vue&type=script&lang=js"
export * from "./tabulator-report-table.vue?vue&type=script&lang=js"
import style0 from "./tabulator-report-table.vue?vue&type=style&index=0&id=5d631099&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports